import React, { useState } from 'react'
import styles from "./MissingCustomerList.module.css"
import { Link, useNavigate } from 'react-router-dom';
import CAN from '../../casl/can';
import { Action, Resource } from "../../casl/constants";
import SectionGuard from '../../hoc/guards/SectionGuard';
import IMAGES from '../../assets/images/images';

function MissingCustomerlist(props) {
    const [isShowMissingCust, setIsShowMissingCust] = useState(false);
    const navigate = useNavigate();

    const toggleMissingCust=()=>{
        setIsShowMissingCust(!isShowMissingCust)
    }

    const handleCustomerClick = (customerId) => {
        if(customerId){
            navigate(`/user-management/customerdetail/${customerId}`);
        }
    };
    let missingmessage = ``
    if(CAN(Action.UPDATE,Resource.CUSTOMERS)){
      missingmessage = <div className={styles.infomsg}>We have observed that the IVC service name has not been added for the customers listed below, resulting in the inability to raise fault tickets. To rectify this, please click the arrow <span className={styles.boldtext}>{`arrow (>)`}</span> icon and take the necessary action to add the IVC service name.</div>
    }else{
      missingmessage = <div className={styles.infomsg}>We have observed that the IVC service name  has not been added for the customers listed below.</div>
    }
    return (
        <div className={styles.missingfincacust}>
          <img className={styles.Vector} src={IMAGES.Vector} alt=""/><span className={styles.infotext}><span className={styles.missingcusttext}>Attention Needed:</span> Please click <span className={styles.clickhere} onClick={toggleMissingCust}>here</span> to view the list of customers whose <span className={styles.boldtext}>IVC service name</span> is missing and has not yet been added to the portal. It is essential to complete this action so that customers can raise their fault tickets. If the code is not added, customers will be unable to raise their fault tickets.</span>
            {isShowMissingCust && ( 
                <div className={styles.alertmessage}>
                    <div className={styles.alertcontent}>
                        <div className={`${styles.header}`}> 
                          <div className={styles.headertext}>IVC service name required for below customers</div>
                          <img className={styles.close} src={IMAGES.close} alt="Close" onClick={toggleMissingCust}/> 
                        </div>
                        {missingmessage}
                        <div className={styles.tableparent}>
                        <div className={`${styles.tableContainer} table-responsive`}>
                          <table className={`table ${styles.customTable}`} style={{margin:0}}>
                            <thead className={styles.tableHeader}>
                              <tr>
                                <th className={styles.tableHeaderCell}><div className={styles.headerContent}>Organisation Legal Name</div></th>
                              </tr>
                            </thead>
                            <tbody className={styles.tabledata}>
                              {props?.missingOneItsmCustomers?.length===0?(<tr className={styles.nodata}>
                                 <td colSpan={1} className={styles.filterdata}>No Customers Found</td>
                              </tr>):
                              props?.missingOneItsmCustomers?.sort((a, b) => a?.displayName?.localeCompare(b?.displayName))?.map((item,rowIndex)=>{
                                // const customerId = encodeURIComponent(item.uniqueCustomerRefId);
                                return(
                                  <tr className={`${rowIndex % 2 === 0 ? styles.evenRow : styles.oddRow}`}>
                                   <td  className={`${styles.tableCell}`}>{item.displayName}
                                   <SectionGuard canAccess={CAN(Action.UPDATE,Resource.CUSTOMERS)}>
                                    <Link  to={`/user-management/customerdetail/${item.uniqueCustomerRefId}`}>
                                      <img className={styles.arrowdown} src={IMAGES.arrows} alt="arrow" 
                                      // onClick={() => handleCustomerClick(item.uniqueCustomerRefId)}
                                      />
                                    </Link>
                                   </SectionGuard>
                                   </td>
                                  </tr>
                                );
                                })}
                            </tbody>
                           </table>
                        </div>
                        </div>
                    </div> 
                </div>
            )}
        </div>
    )
}

export default MissingCustomerlist
